/**
 * Nutriop Longevity Header Enhancements
 * Compatible with FLUX Theme sticky-header element
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // Add smooth hover effects to navigation
  const navItems = document.querySelectorAll('.nav-menu-item');
  navItems.forEach(item => {
    item.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-1px)';
    });
    
    item.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
    });
  });
  
  // Enhance cart icon animation
  const cartIcon = document.querySelector('.header__icon--cart');
  if (cartIcon) {
    cartIcon.addEventListener('click', function(e) {
      // Add bounce animation
      this.style.animation = 'iconBounce 0.3s ease-out';
      setTimeout(() => {
        this.style.animation = '';
      }, 300);
    });
  }
  
  // Add premium scroll effects
  let lastScroll = 0;
  const header = document.querySelector('sticky-header.header-wrapper');
  
  if (header) {
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;
      
      // Add/remove scrolled class for additional styling
      if (currentScroll > 100) {
        header.classList.add('premium-scrolled');
      } else {
        header.classList.remove('premium-scrolled');
      }
      
      lastScroll = currentScroll;
    });
  }
  
  // Enhance dropdown menus
  const dropdowns = document.querySelectorAll('.navigation-menu details');
  dropdowns.forEach(dropdown => {
    const summary = dropdown.querySelector('summary');
    const content = dropdown.querySelector('.navigation-submenu, .mega-menu__content');
    
    if (summary && content) {
      // Add smooth opening animation
      dropdown.addEventListener('toggle', function() {
        if (this.open) {
          content.style.opacity = '0';
          content.style.transform = 'translateY(-10px)';
          
          setTimeout(() => {
            content.style.transition = 'all 0.3s ease';
            content.style.opacity = '1';
            content.style.transform = 'translateY(0)';
          }, 10);
        }
      });
    }
  });
  
  // Mobile menu enhancements
  const mobileMenuButton = document.querySelector('.header__icon--menu');
  const menuDrawer = document.querySelector('.menu-drawer');
  
  if (mobileMenuButton && menuDrawer) {
    // Add smooth drawer animation
    mobileMenuButton.addEventListener('click', function() {
      setTimeout(() => {
        if (menuDrawer.parentElement.hasAttribute('open')) {
          menuDrawer.style.animation = 'slideIn 0.3s ease-out';
        }
      }, 10);
    });
  }
  
  // Add loading state to search
  const searchInput = document.querySelector('.search__input');
  if (searchInput) {
    searchInput.addEventListener('input', function() {
      if (this.value.length > 2) {
        this.classList.add('searching');
      } else {
        this.classList.remove('searching');
      }
    });
  }
});

// Add CSS animations
const style = document.createElement('style');
style.textContent = `
  @keyframes iconBounce {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.1); }
  }
  
  @keyframes slideIn {
    from {
      transform: translateX(-100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  .premium-scrolled {
    transition: all 0.3s ease !important;
  }
  
  .searching {
    background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDE4QzE0LjQxODMgMTggMTggMTQuNDE4MyAxOCAxMEMxOCA1LjU4MTcyIDE0LjQxODMgMiAxMCAyQzUuNTgxNzIgMiAyIDUuNTgxNzIgMiAxMEMyIDE0LjQxODMgNS41ODE3MiAxOCAxMCAxOFoiIHN0cm9rZT0iI0ZGNkI2QiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+');
    background-repeat: no-repeat;
    background-position: right 20px center;
    background-size: 20px;
  }
  
  /* Additional hover effects */
  .nav-menu-item {
    transition: all 0.3s ease !important;
  }
  
  .header__icon {
    transition: all 0.3s ease !important;
  }
  
  /* Smooth mega menu animations */
  .mega-menu__content,
  .navigation-submenu {
    animation: fadeInDown 0.3s ease-out;
  }
  
  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
document.head.appendChild(style);